import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
var _excluded = ["disabled", "extraProps", "value", "onChange"];

/**
 * @file Group 分组操作类
 */
import { guid } from '@tencent/glue-util-helper';
export var Group = /*#__PURE__*/function () {
  function Group(conf) {
    _classCallCheck(this, Group);

    // 当前激活的组
    this.group = Group.GROUP_FREE; // 当前是否已经销毁

    this.disposed = false; // 子项目索引

    this.map = {};
    var disabled = conf.disabled,
        extraProps = conf.extraProps,
        value = conf.value,
        onChange = conf.onChange;
    this.extraProps = extraProps;
    this.disabled = disabled;
    this.value = value;
    this.onChange = onChange;
  } // 更新组信息


  _createClass(Group, [{
    key: "updateGroupOptions",
    value: function updateGroupOptions(conf) {
      var _this = this;

      var disabled = conf.disabled,
          extraProps = conf.extraProps,
          value = conf.value,
          onChange = conf.onChange,
          extra = _objectWithoutProperties(conf, _excluded);

      this.extraProps = extraProps;
      this.disabled = disabled;
      this.value = value;
      this.onChange = onChange; // 最后一个生效

      var group = Group.GROUP_FREE;
      Object.keys(this.map).forEach(function (key) {
        var item = _this.map[key];

        if (value.indexOf(item.value) >= 0) {
          group = item.group;
        }
      });
      this.group = group; // 更新了组信息

      Object.keys(this.map).forEach(function (key) {
        return _this.map[key].emitGroupChange();
      });
      return extra;
    }
  }, {
    key: "getMap",
    value: function getMap() {
      return this.map;
    }
  }, {
    key: "onItemChange",
    value: function onItemChange(item, checked) {
      if (item.free) {
        this.onChange([]);
        this.group = Group.GROUP_FREE;
        return;
      }

      var value = this.value.slice();
      var index = this.value.indexOf(item.value);

      if (index >= 0) {
        if (!checked) {
          value.splice(index, 1);
          this.onChange(value);
        }

        return;
      }

      if (!checked) {
        return;
      }

      if (value.length === 0 || item.group !== this.group) {
        this.onChange([item.value]);
        return;
      }

      var currentValue = typeof item.onSelect === 'function' ? item.onSelect(item.value, value) : value.concat(item.value);
      this.onChange(currentValue);
    }
  }, {
    key: "isItemChecked",
    value: function isItemChecked(item) {
      return item.free ? this.value.length === 0 : this.value.indexOf(item.value) >= 0;
    } // 注册子项目

  }, {
    key: "register",
    value: function register(item) {
      if (this.map[item.id]) {
        console.error("duplicated group item: ".concat(item.value));
      } // 如果初始化的值在已选择的值中，设置group，初始值Group正确性依赖外部


      if (this.value.indexOf(item.value) >= 0) {
        this.group = item.group;
      }

      this.map[item.id] = item;
    } // 解除子项目注册

  }, {
    key: "unregister",
    value: function unregister(item) {
      if (this.disposed) {
        return;
      }

      if (!this.map[item.id]) {
        console.error("item ".concat(item.value, " is not registered in this group"));
      }

      delete this.map[item.id]; // 如果被删除的元素在值里

      var value = this.value.slice();
      var index = value.indexOf(item.value);

      if (index >= 0) {
        value.splice(index, 1);
        this.onChange(value);
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.disposed = true;
      Object.values(this.map).forEach(function (item) {
        return item.dispose();
      });
      this.map = {};
    }
  }]);

  return Group;
}();
Group.GROUP_FREE = guid();